import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import type { LinkedBroadcast } from "@/api/broadcastV2Audiences";

import { LinkedBroadcastsModalTable } from "@/components/LinkedBroadcastsModalTable";

interface LinkedBroadcastsDeleteBlockedModalProps {
  open: boolean;
  broadcasts: LinkedBroadcast[];
  onClose: () => void;
}

export function LinkedBroadcastsDeleteBlockedModal({
  open,
  broadcasts,
  onClose,
}: LinkedBroadcastsDeleteBlockedModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="broadcast-delete-blocked-title"
    >
      <DialogTitle id="broadcast-delete-blocked-title">
        Cannot delete tile
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Typography variant="body2" color="text.secondary">
            This tile is linked to one or more broadcasts. Unlink it from the
            broadcasts below before you can delete it.
          </Typography>
          <LinkedBroadcastsModalTable broadcasts={broadcasts} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ gap: 2, justifyContent: "flex-end", px: 4, pb: 3 }}>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
